import {Component, OnInit, ViewChild, OnDestroy}       from '@angular/core';
import {NgbActiveModal}                     from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

import {ItemComponent}                      from "../../articles/item/item.component";
import {Message}                            from "../../services/message/message";
import {MessageEntry}                       from "../../services/message/message-entry";
import {Permissions}                        from "../../services/permissions/permissions";
import {Tag}                                from "../../services/tag/tag";
import {TagService}                         from "../../services/tag/tag.service";

import {Subscription}                       from "rxjs/Subscription";



@Component({
	selector: 'app-tag-admin',
	templateUrl: './tag-admin.component.html',
	styleUrls: ['./tag-admin.component.css']
})


/**
 * Allow the addition, editing and deletion of Tag objects.
 */
export class TagAdminComponent implements OnInit, OnDestroy {


	message:Message;
	tag: Tag;
	tagDelete:Subscription;
	tForm: FormGroup;



	/**
	 * Initialize the component.
	 *
	 * @param {NgbActiveModal} activeModal     Used to close the page.
	 * @param {FormBuilder} fb                 Used to create the page objects.
	 * @param {TagService} tagService          Used when deleting Tag objects.
	 */
	constructor(
		public activeModal: NgbActiveModal,
        private fb: FormBuilder,
	    private tagService: TagService,
	) {}


	/**
	 * Unsubscribe to avoid memory leaks.
	 */
	ngOnDestroy() {

		if (this.tagDelete) {
			this.tagDelete.unsubscribe();
		}

	}

	/**
	 * Create the form elements using FormBuilder.
	 */
	ngOnInit() {

		// Initialize the data structure for the page.
		this.tForm = this.fb.group({
			tag: ['', [Validators.required,Validators.minLength(1), Validators.maxLength(200),]],
			id: [-1, [Validators.required, Validators.min(-1)]],
		});

		// Set up the message window with an initial message.
		let me:MessageEntry = new MessageEntry();
		me.message = 'Ready';
		me.level = 1;
		this.message = new Message(me);
		this.message.show();

	}


	/**
	 * Lets me talk to the Tag typeahead.
	 */
	@ViewChild('tagTypeahead')
	tagTypeahead: any;


	/**
	 * Fill the fields with default data.
	 */
	clear():void {

		this.tForm.controls['id'].setValue(-1);
		this.tagTypeahead.typeaheadTagInput.nativeElement.value = '';
		this.tagTypeahead.searchFailed = false;
		this.tagTypeahead.searching = false;

		// Notify the user.
		let me:MessageEntry = new MessageEntry();
		me.message = 'Ready';
		me.level = 1;
		this.message.add(me, true);
		this.message.show();

	}


	/**
	 * Delete the current item.
	 */
	deleteTag():void {

		// Give them the option to cancel.
		if (! window.confirm('Are you sure you want to delete this tag?')) {
			return;
		}

		if (false === Permissions.checkPermission(Permissions.SUPER_USER)) {

			// You don't have permission; show the error and return.
			let me:MessageEntry = new MessageEntry();
			me.message = 'You do not have permission to delete tags. Contact your administrator if this is in error.';
			me.level = 4;
			this.message = new Message(me);
			this.message.show();

			return;

		}

		if (-1 === this.tForm.controls['id'].value) {

			this.clear();
			this.tagTypeahead.typeaheadTagInput.nativeElement.value = '';
			return;

		}

		// Notify the user and save the current tag value.
		let me:MessageEntry = new MessageEntry();
		me.message = "Deleting '" + this.tagTypeahead.typeaheadTagInput.nativeElement.value + "' ...";
		me.level = 1;
		this.message.add(me, true);
		this.message.show();
		let tagvalue:string = this.tagTypeahead.typeaheadTagInput.nativeElement.value;

		if (this.tagDelete) {

			this.tagDelete.unsubscribe();

		}

		this.tagDelete = this.tagService.deleteTag(this.tForm.controls['id'].value).subscribe(

			() => {

				this.clear();

				// Notify the user.
				let me:MessageEntry = new MessageEntry();
				me.message = "'" + tagvalue + "' deleted";
				me.level = 2;
				this.message.add(me, true);
				this.message.show();

				this.tagTypeahead.typeaheadTagInput.nativeElement.value = '';

			},
			() => {

				// Notify the user.
				let me:MessageEntry = new MessageEntry();
				me.message = "Failed to delete '" + tagvalue + "'";
				me.level = 4;
				this.message.add(me, true);
				this.message.show();

			}

		);

	}


	/**
	 * Returns true if the Delete Tag button should be hidden.
	 *
	 * @return {boolean} True if it should be hidden, false otherwise.
	 */
	hideDeleteButton():boolean {

		return (this.tForm.controls['id'].value === -1) || (! Permissions.checkPermission(Permissions.SUPER_USER));

	}


	/**
	 * Update everything when the selection changes.
	 *
	 * @param {any} event  The new Tag object.
	 */
	onTagChange(event: any): void {

		let tag: Tag = new Tag(event);
		tag.tag = ItemComponent.replaceWordCharacters(tag.tag);
		this.tForm.controls['tag'].setValue(tag.tag);
		this.tForm.controls['id'].setValue(tag.id);

		// This uses a reference to the Tag typeahead to set the text box to the selected tag.
		this.tagTypeahead.typeaheadTagInput.nativeElement.value = tag.tag;

		// Notify the user.
		let me:MessageEntry = new MessageEntry();
		me.message = "'" + tag.tag + "' chosen";
		me.level = 2;
		this.message.add(me, true);
		this.message.show();

	}


}



// WEBPACK FOOTER //
// ./src/app/admin/tag/tag-admin.component.ts